import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { ButtonAlpha, StackBlock, StackInline, TextAlpha } from '@yonderland/andes-react';
import { getHomepageUrl } from '@as-react/common-utils';
export const EmptyBasketBlock = () => {
    const { t } = useTranslation(I18N_NAMESPACES.checkout);
    const { rootWithLanguageSuffix } = useAemConfig();
    return (_jsx(StackInline, { contentAlign: "center", children: _jsxs(StackBlock, { gap: "4", children: [_jsx(TextAlpha, { testId: "empty_basket_message", children: t('basket.emptyBasket') }), _jsx(ButtonAlpha, { theme: "branded", testId: "empty_basket_action_button", text: t('basket.startShopping'), onClick: () => {
                        window.location.href = getHomepageUrl(rootWithLanguageSuffix);
                    } })] }) }));
};
